import { TronWeb } from "tronweb";
import { TronLinkAdapter } from '@tronweb3/tronwallet-adapter-tronlink';

import abi_TOKENTRC20 from "../abi/tokenTRC20";
import abi_CIROFEE from "../abi/cirofee";
import abi_CIROFEE_pro from "../abi/CiroFeePro.json";
import abi_BRUTUS_SS from "../abi/BrutusSendStables.json";
import abi_TOKEN_SALES from "../abi/TokenSales-v1.json"


const CryptoJS = require("crypto-js");
const env = process.env

const conProxy = false;
const testnet = false;//shasta

const RED = env.REACT_APP_RED || "https://api.trongrid.io"
let ProxyURL = conProxy && env.REACT_APP_PROXY_URL ? env.REACT_APP_PROXY_URL : "" 

let constantes = {
  SC: { address: "TXSvbF6MSukLMrYiLA5PfLHaPh97up2aGm", abi: abi_CIROFEE },//contrato CiroTRX
  SC2: { address: "TU7B67Bf6C4yMWzMP7sjDNFsp4nL4QGLbz", abi: abi_CIROFEE_pro.abi }, // CiroFee pro
  SC3: { address: "TAXjFgPkVssyWBzYS2HYaYXt8ktKQ24LZK", abi: abi_BRUTUS_SS }, // Brutus Send Stable
  SC4: { address: "TYBi9gmsA8ZiLiXRZtuUCPeiK7ynU62P5V", abi: abi_BRUTUS_SS }, // Brutus Token Transfers PRO
  SC5: {address: "TWthG7u1rqTumhtmkn4ioEAqKFJQvFUv2n",abi:abi_TOKEN_SALES }, // ventas token sales
  USDT: { address: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t", abi: abi_TOKENTRC20 },//token USDT
  proxy: ProxyURL,
  BRUTUS_API: ProxyURL + process.env.REACT_APP_API_URL + "api/v1/",
  PRICE: ProxyURL + env.REACT_APP_API_URL + "api/v1/precio/BRUT"
}

if (testnet) {

  constantes.SC.address = "TRxxZV3t7bSx1NACMN5QmTfsjBTonQ486F";//ciro TRX

  constantes.USDT.address = "TExwHCjZYbb7ToQUfQY5JgumwbcXAgeaVd";//token USDT

}


constantes.tronWeb = new TronWeb({
  fullHost: RED,
})

constantes.adapter = new TronLinkAdapter();

async function rentResource(wallet_orden, recurso, cantidad, periodo, temporalidad, precio, signedTransaction) {

  if (recurso === "bandwidth" || recurso === "band") {
    recurso = "band"
  } else {
    recurso = "energy"
  }

  let time = periodo

  if (temporalidad === "h" || temporalidad === "hour" || temporalidad === "hora") {
    time = periodo + temporalidad
  }

  if (temporalidad === "m" || temporalidad === "min" || temporalidad === "minutes" || temporalidad === "minutos") {
    time = periodo + "min"
  }

  let data = {
    "wallet": wallet_orden,
    "resource": recurso,
    "amount": cantidad,
    "duration": time,

    "transaction": signedTransaction,
    "to_address": env.REACT_APP_WALLET_API,
    "precio": TronWeb.toSun(precio),

    "expire": Date.now() + (60 * 1000),

    "id_api": env.REACT_APP_USER_ID,
    "token": env.REACT_APP_TOKEN,
  }

  data = CryptoJS.AES.encrypt(JSON.stringify(data), env.REACT_APP_SECRET).toString();

  let consulta = await fetch(constantes.BRUTUS_API + "rent/energy", {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ user: env.REACT_APP_USER_C, data })
  }).then((r) => r.json())
    .catch((e) => {
      console.log(e.toString());
      return { result: false, hash: signedTransaction.txID, msg: "API-Error" }
    })

  return consulta

}

function getRandomInt(max) { return Math.floor(Math.random() * max); }

function delay(s) { return new Promise(res => setTimeout(res, s * 1000)); }


export default { getRandomInt, rentResource, delay, ...constantes }